import { addMissingFields } from "./addMissingFields";
import { applyEditTrackingFields } from "./applyEditTrackingFields";
import { castDateFields } from "./castDateFields";
import { castDateToFireStoreDate } from "./castDateToFireStoreDate";
import { firestoreAutoId } from "./firestoreAutoId";
import formatDateFld from "./formatDateFld";
import { getMaxNo } from "./getMaxNo";
import { saveToFirestore } from "./saveToFirestore";

export async function getExcelFeatures(
  user,
  importData,
  importFields,
  editSchema,
  requiredFds,
  project,
  tableName,
  related_id_field,
  related_id,
) {
  //check for required name field
  requiredFds.forEach((rd) => {
    const nameFld = importFields.find((f) => f.selected === rd);
    if (nameFld === undefined) {
      throw new Error(`${rd} field is required`);
    }
  });

  var newEquip = [];
  importData.forEach((e) => {
    var row = {};
    importFields.forEach((fd) => {
      row[
        fd["selected"] === "New Attribute" ? fd["attribute"] : fd["selected"]
      ] =
        fd["selected"] === "New Attribute"
          ? e[fd["name"]]
          : e[fd["name"]].toString();
    });
    row.id = "new";
    row = addMissingFields(row, editSchema);

    if (row.hasOwnProperty("Date")) {
      row["Date"] = formatDateFld(row["Date"]);
      // newEquip[i] = castDateFields(newEquip[i], editSchema);
      // newEquip[i] = castDateToFireStoreDate({ ...newEquip[i] });
    }
    newEquip.push(row);
  });

  var maxNo = getMaxNo(project[tableName]);
  for (let i = 0; i < newEquip.length; i++) {
    newEquip[i] = applyEditTrackingFields(newEquip[i], user);
    newEquip[i] = castDateFields(newEquip[i], editSchema);
    newEquip[i] = castDateToFireStoreDate({ ...newEquip[i] });
    newEquip[i].id = firestoreAutoId();
    // newEquip[i].project_id = project.id;
    if (related_id_field !== null) {
      newEquip[i][related_id_field] = related_id;
    }
    newEquip[i].fileCount = 0;
    if (tableName !== "Comments") {
      newEquip[i].commentCount = 0;
    }
    if (tableName === "Observations") {
      newEquip[i].issueCount = 0;
    } else if (tableName === "Equipment") {
      newEquip[i].issueCount = 0;
      newEquip[i].checklistCount = 0;
    } else if (tableName === "Issues") {
      project.issues_log.push(
        castDateToFireStoreDate({
          id: newEquip[i].id,
          Status: newEquip[i].Status,
          user: user.displayName,
          uid: user.uid,
          date: new Date(),
        }),
      );
    }
    newEquip[i].No = isNaN(maxNo) ? 1 : maxNo;
    maxNo += 1;
  }

  project[tableName] = project[tableName].concat(newEquip);
  await saveToFirestore("projects", project);

  var freshFeatures = [...project[tableName]];
  freshFeatures.forEach((item) => {
    item.Selected = false;
  });
  return { project, newEquip, freshFeatures };
}
